import React, { useState } from 'react';
import './App.css';
import SharingForm from './components/SharingForm';
import PreviewCard from './components/PreviewCard';

function App() {
  const [formData, setFormData] = useState({
    postUrl: '',
    title: '',
    featuredImage: '',
    excerpt: '',
    accentColor: '#667eea',
    platforms: {
      bluesky: true,
      threads: true,
      facebook: true,
      mastodon: true,
      reddit: true,
      linkedin: true,
      email: true
    }
  });
  const [originalMetadata, setOriginalMetadata] = useState(null);

  const handleFormChange = (data) => {
    setFormData(data);
    // If this is metadata from URL fetch, store the original metadata
    if (data.originalMetadata) {
      setOriginalMetadata(data.originalMetadata);
    }
  };

  const handleReset = () => {
    setFormData({
      postUrl: '',
      title: '',
      featuredImage: '',
      excerpt: '',
      accentColor: '#667eea',
      platforms: {
        bluesky: true,
        threads: true,
        facebook: true,
        mastodon: true,
        reddit: true,
        linkedin: true,
        email: true
      }
    });
    setOriginalMetadata(null);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>SWS Email Sharing Tool</h1>
        <p>Create social sharing links for your content</p>
      </header>
      
      <main className="App-main">
        <div className="main-layout">
          <div className="form-section">
            <SharingForm 
              onChange={handleFormChange} 
              initialData={formData} 
              onReset={handleReset}
            />
          </div>
          <div className="preview-section">
            <PreviewCard formData={formData} originalMetadata={originalMetadata} />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
